import { render } from "./presentations.vue?vue&type=template&id=6f253cb4&scoped=true"
import script from "./presentations.vue?vue&type=script&lang=js"
export * from "./presentations.vue?vue&type=script&lang=js"

import "./presentations.vue?vue&type=style&index=0&id=6f253cb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f253cb4"]])

export default __exports__